module.exports = __webpack_public_path__ + "static/media/dotted-box.3643326b.svg";